import type { BufferService } from '@exiftrator/shared';

export function createBufferService(): BufferService {
  return {
    toBase64(buffer: Uint8Array): string {
      let binary = '';
      const len = buffer.length;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(buffer[i]);
      }
      return btoa(binary);
    },

    fromBase64(base64: string): Uint8Array {
      const binary = atob(base64);
      const len = binary.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return bytes;
    },

    toBinaryString(buffer: Uint8Array): string {
      let binary = '';
      const len = buffer.length;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(buffer[i]);
      }
      return binary;
    },

    fromBinaryString(binaryString: string): Uint8Array {
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes;
    },

    concat(buffers: Uint8Array[]): Uint8Array {
      const totalLength = buffers.reduce((sum, buf) => sum + buf.length, 0);
      const result = new Uint8Array(totalLength);
      let offset = 0;
      for (const buffer of buffers) {
        result.set(buffer, offset);
        offset += buffer.length;
      }
      return result;
    },
  };
}
